var main = new (function(){

    var that = this;
    
    this.init = function(){
        var bannerbottom = $('.sliderprod'),
            items = $('header nav li'),
            menuMob = $('#hamburguer');    


        function mediaqueryresponse(mql){
            if (!mql.matches){ // if media query matches
                if($('div.inner').parent().is( "div.mobile" ))
            {   
                $('div.inner').unwrap();
            } 
            }else{
                $( ".inner" ).wrapAll( "<div class='mobile' />");
            }
        }

        var mql = window.matchMedia("only screen and (max-width: 991px)")
        mediaqueryresponse(mql) // call listener function explicitly at run time
        mql.addListener(mediaqueryresponse) // attach listener function to listen in on state changes
        
        $('.mobile').height($( document ).height());

        menuMob.click(function(){
            $('#hamburguer, .mobile').toggleClass('open');
        });
        
        if(bannerbottom.length>0){
            bannerbottom.owlCarousel({
                items:1,
                loop:true,
                dots:true,
                nav:false,
                autoplay:true,
                smartSpeed:1000,
                fluidSpeed:1000
            }); 
        }
        $('.productos .sliderprod,.wrappBanner .wrappb1,.thumbs').each(function(index, element){
            var itemsowl = $(this).find('.owl-item'),
                ctrls = $(this).find('.owl-controls');
  
            if(itemsowl.length < 4 ){
                ctrls.hide();
            }
        })
        
        setNavigation();

        function setNavigation() {

            var tUrl = window.location.pathname;
            items.each(function(){
            var ihref = $(this).find('a').attr('href');
            if(tUrl==ihref){
                $(this).find('a').addClass('current');
            }

            })
        } 
        
    };

})();